import script from "./PantallaPersona.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaPersona.vue?vue&type=script&setup=true&lang=js"

import "./PantallaPersona.vue?vue&type=style&index=0&id=e4654156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4654156"]])

export default __exports__